/**
 * Mock 세션 4종 — master / carwash owner / academy owner / academy staff
 *
 * ⚠️ 테스트/dev fallback 전용. 실사용 세션은 backend GET /api/v1/owner-console/session
 * 응답을 쓴다 (permissions/SessionContext.jsx). production 빌드에서는 mock 진입 경로가 없다.
 *
 * shape 는 backend OwnerConsoleService.buildSession 응답과 동일하게 유지할 것:
 *   user:  { id, name, role }   — role 은 admin enum ('manager' = 점주, 'staff' = 직원)
 *   store: { id, name, category, capabilities: [] }
 *   permissions: []             — backend owner-console-permissions.ts 매핑과 동기화
 */

export const MOCK_SESSIONS = {
  master: {
    key: 'master',
    label: '마스터',
    user: { id: 'mock-master-1', name: '채수원', role: 'master' },
    store: {
      id: 'mock-store-carwash-1',
      name: '모던워시 전주점',
      code: 'jeonju',
      category: 'carwash',
      capabilities: ['lpr', 'kiosk', 'washProgram', 'rfCard'],
    },
    storeOptions: [
      {
        id: 'mock-store-carwash-1',
        name: '모던워시 전주점',
        category: 'carwash',
        code: 'jeonju',
      },
      {
        id: 'mock-store-academy-1',
        name: '모구 수학학원',
        category: 'academy',
        code: 'academy',
      },
    ],
    permissions: [
      'dashboard.read',
      'members.read',
      'membership.read',
      'usage.read',
      'payment.read',
      'settlement.read',
      'audit.read',
      'notice.read',
      'settings.manage',
      'websiteStores.manage',
      'vehicle.read',
      'lpr.read',
      'kiosk.read',
      'washProgram.read',
      'rfCard.read',
      'students.read',
      'students.manage',
      'parents.read',
      'classes.read',
      'classes.manage',
      'attendance.read',
      'tuition.read',
      'tuition.manage',
      'member.notify',
      'lockers.read',
      'lessons.read',
      'machines.read',
      'orders.read',
      'pickup.read',
    ],
  },

  carwashOwner: {
    key: 'carwashOwner',
    label: '세차장 점주',
    user: { id: 'mock-user-1', name: '김워시', role: 'manager' },
    store: {
      id: 'mock-store-carwash-1',
      name: '모던워시 전주점',
      code: 'jeonju',
      category: 'carwash',
      capabilities: ['lpr', 'kiosk', 'washProgram', 'rfCard'],
    },
    permissions: [
      'dashboard.read',
      'members.read',
      'membership.read',
      'vehicle.read',
      'lpr.read',
      'kiosk.read',
      'payment.read',
      'settings.manage',
      'member.notify',
    ],
  },

  academyOwner: {
    key: 'academyOwner',
    label: '학원 원장',
    user: { id: 'mock-user-2', name: '박원장', role: 'manager' },
    store: {
      id: 'mock-store-academy-1',
      name: '모구 수학학원',
      category: 'academy',
      capabilities: ['attendance'],
    },
    // backend owner-console-permissions.ts 의 manager 매핑과 동기화 유지
    permissions: [
      'dashboard.read',
      'members.read',
      'membership.read',
      'students.read',
      'students.manage',
      'parents.read',
      'classes.read',
      'classes.manage',
      'attendance.read',
      'tuition.read',
      'tuition.manage',
      'payment.read',
      'settings.manage',
      'member.notify',
    ],
  },

  academyStaff: {
    key: 'academyStaff',
    label: '학원 직원',
    user: { id: 'mock-user-3', name: '이직원', role: 'staff' },
    store: {
      id: 'mock-store-academy-1',
      name: '모구 수학학원',
      category: 'academy',
      capabilities: ['attendance'],
    },
    permissions: ['dashboard.read', 'students.read', 'attendance.read'],
  },
};

export const DEFAULT_SESSION_KEY = 'carwashOwner';
